import {
  Modal,
  Box,
  SpaceBetween,
  Header,
  Button,
  CopyToClipboard,
  Spinner,
} from "@amzn/awsui-components-console";
import CodeView from "@amzn/awsui-code-view-components-console/code-view";
import jsonHighlight from "@amzn/awsui-code-view-components-console/highlight/json";
import {
  Ard,
  GetArdResponse,
} from "@amzn/fuse-accounting-central-datastore-client";
import React from "react";

interface ViewRawArdModalProps {
  visible: boolean;
  onDismiss: () => void;
  selectedArdDetailed: GetArdResponse | null;
  selectedArd: Ard | null;
}

export function ViewRawArdModal({
  visible,
  onDismiss,
  selectedArdDetailed,
  selectedArd,
}: ViewRawArdModalProps) {
  const ardJson = selectedArdDetailed?.ard
    ? JSON.stringify(selectedArdDetailed.ard, null, 2)
    : null;

  return (
    <Modal
      size="large"
      visible={visible}
      onDismiss={onDismiss}
      closeAriaLabel="Close modal"
      header={
        <Header variant="h2">
          Raw ARD
          {selectedArd?.id && (
            <span
              style={{
                fontSize: "14px",
                fontWeight: "normal",
                marginLeft: "10px",
              }}
            >
              ({selectedArd.id})
            </span>
          )}
        </Header>
      }
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            {ardJson && (
              <CopyToClipboard
                copyButtonText="Copy JSON"
                copyErrorText="Failed to copy JSON"
                copySuccessText="ARD JSON copied"
                textToCopy={ardJson}
                variant="button"
              />
            )}
            <Button onClick={onDismiss} variant="primary">
              Close
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {!ardJson ? (
        <Box textAlign="center" padding="l">
          <Spinner size="large" />
          <Box margin={{ top: "s" }}>Loading ARD data...</Box>
        </Box>
      ) : (
        <CodeView content={ardJson} highlight={jsonHighlight} />
      )}
    </Modal>
  );
}
